import { RedirectResponse } from '../../../team-apis/otterdam/redirect-response';

export function isRedirectResponse<T extends object>(
  response: T | RedirectResponse,
): response is RedirectResponse {
  return 'redirect_to' in response;
}
